export enum PaymentScreenVersion {
  v3_2 = '3.2',
  v3_3 = '3.3',
  v3_4 = '3.4',
  default = 'default',
}

export enum LTPPaymentScreenVersion {
  default = 'default',
}

export function getVersionWithHyphen(version: PaymentScreenVersion): string {
  return version.replace(/\./g, '-')
}
